import { auth } from "../firebase/config";

const signInUser = async (email: string, password: string) => {
  try {
    const res = await auth.signInWithEmailAndPassword(email, password);
    const { user } = res;
    return user;
  } catch (error) {
    throw error;
  }
};

export default signInUser;
